
export function useDateBlocker(blockedDates, minDate, maxDate, blockWeekends) {

  const disabledDates = new Set()
  if (blockedDates) {
    blockedDates.forEach(d => disabledDates.add(new Date(d).toDateString()))
  }

  const min = ref(minDate ?? null);
  const max = ref(maxDate ?? null)
  const model = ref(min.value ?? new Date())

  watch([min, max], ([newMin, newMax]) => {
    if (newMin) {
      const modMin = newMin
      while (checkBlockedDate(modMin)) {
        modMin.setDate(modMin.getDate() + 1)
      }
      min.value = modMin
      if (model.value < min.value) model.value = min.value
    }

    if (newMax) {
      const modMax = newMax
      while (checkBlockedDate(modMax)) {
        modMax.setDate(modMax.getDate() + 1)
      }
      max.value = modMax
      if (model.value > max.value) model.value = max.value
    }
    setModelToNextAvailableDate()
  }, { immediate: true })

  function setBlockedDates(blocks) {
    disabledDates.clear()
    blocks.forEach(d => disabledDates.add(new Date(d).toDateString()))
    setModelToNextAvailableDate()
  }

  // Disabled check function for datepicker
  function checkBlockedDate(date) {
    const day = date.getDay()
    const isWeekend = blockWeekends ? (day === 0 || day === 6) : false
    const isBlocked = disabledDates.has(date.toDateString())
    return isWeekend || isBlocked
  }

  function appendBlockedDate(d) {
    disabledDates.add(d.toDateString())
    setModelToNextAvailableDate()
  }

  function removeBlockedDate(d) {
    disabledDates.delete(d.toDateString())
  }

  function setModelToNextAvailableDate() {
    while (checkBlockedDate(model.value)) {
      const mod = new Date(model.value) // Create a new Date instance to trigger reactivity
      mod.setDate(mod.getDate() + 1)
      model.value = mod
    }
    if (model.value > max.value) model.value = max.value
  }

  return {
    min,
    max,
    model,
    disabledDates,
    setBlockedDates,
    checkBlockedDate,
    appendBlockedDate,
    removeBlockedDate,
  }
}
